import { init } from './consumer';
import { registerHeightReporter } from './heightReporter';
var searchParams = new URL(self.location.href).searchParams;
var origin = searchParams.get('origin') || '';
try {
    init({
        postMessage: window.parent.postMessage.bind(window.parent),
        origin: origin,
    });
    registerHeightReporter();
}
catch (e) {
    console.error(e);
}
export * from './sdk';
export * from './types';
//# sourceMappingURL=index.js.map